import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { Box, IconButton, Typography } from '@mui/material';
import React, { FunctionComponent } from 'react';
import { useNavigate } from 'react-router-dom';

export const LegalMentions: FunctionComponent = () => {
  const navigate = useNavigate();

  const goBack = () => {
    navigate('/');
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
        <IconButton onClick={goBack} size="large">
          <ChevronLeftIcon fontSize="large" />
        </IconButton>
        <Typography variant="h4">Mentions légales</Typography>
      </Box>
      <Box sx={{ mx: 6, mt: 4 }}>
        <Typography variant="h6">Informations générales</Typography>
        <Typography variant="body2">Informations générales</Typography>
        <Typography variant="body2">Site: flute3.sale</Typography>
        <Typography variant="body2">
          Faluche Libre Universitaire TroyennE, FLUTE
        </Typography>
        <Typography variant="body2">
          Adresse : 34 rue Voltaire 10000 Troyes
        </Typography>
        <Typography variant="body2">Mail: laflute.troyes@gmail.com</Typography>
        <Typography variant="body2">Président: Eve Bernhard</Typography>

        <Typography variant="h6">Respect des lois en vigueur</Typography>
        <Typography variant="body2">
          Le site flute3.sale respecte la vie privée de l’internaute et se
          conforme strictement aux lois en vigueur sur la protection de la vie
          privée et des libertés individuelles. Aucune information personnelle
          n’est collectée à votre insu. Aucune information personnelle n’est
          cédée à des tiers. Les courriels, les adresses électroniques ou autres
          informations nominatives dont ce site est destinataire ne font l’objet
          d’aucune exploitation et ne sont conservés que pour la durée
          nécessaire à leur traitement.
        </Typography>

        <Typography variant="h6">
          Droit des internautes : droit d’accès et de rectification
        </Typography>
        <Typography variant="body2">
          Conformément aux dispositions de la loi n°78-17 du 6 janvier 1978
          relative à l’informatique, aux fichiers et aux libertés, les
          internautes disposent d’un droit d’accès, de modification, de
          rectification et de suppression des données qui les concernent. Ce
          droit est exerçable en envoyant un mail à laflute.troyes@gmail.com
        </Typography>

        <Typography variant="h6">Cookies</Typography>
        <Typography variant="body2">
          L’utilisation de ce site requiert l’installation d’un cookie, fichier
          texte qui enregistre des informations relatives à la navigation de
          votre ordinateur sur notre site (les pages consultées, la date et
          l’heure de consultation…). En aucun cas, le cookie ne permet de vous
          identifier et n’est utilisé à des fins commerciales. Nous vous
          rappelons que vous pouvez vous opposer à l’enregistrement de cookies
          en configurant votre ordinateur.
        </Typography>

        <Typography variant="h6">Droit de propriété intellectuelle</Typography>
        <Typography variant="body2">
          Toutes les informations ou documents contenus dans le site ainsi que
          tous les éléments créés pour le site sont soit la propriété de
          l’Association FLUTE, soit font l’objet de droit d’utilisation, de
          reproduction et de représentation consentis au profit de l’Association
          FLUTE.
        </Typography>
        <Typography variant="body2">
          Toutes les informations de ce site relèvent des législations
          françaises et internationales protégeant les droits d’auteur.
        </Typography>
        <Typography variant="body2">
          Aucune licence, ni aucun droit autre que celui de consulter le site
          n’est conféré à quiconque au regard des droits de propriété
          intellectuelle. La reproduction des documents du site est autorisée à
          des fins exclusives d’information pour un usage personnel et privé,
          toute reproduction et toute utilisation de copie réalisée à d’autres
          fins est expressément interdite et soumise à l’autorisation préalable
          et expresse de l’Association FLUTE.
        </Typography>
        <Typography variant="body2">
          La dénomination Association FLUTE, les logos et autres produits et
          marques cités sur le site sont la propriété de l’Association FLUTE et
          ne peuvent en conséquence utilisés sans l’autorisation écrite
          préalable de l’Association FLUTE.
        </Typography>

        <Typography variant="h6">Liens hypertexte</Typography>
        <Typography variant="body2">
          L’Association FLUTE ne peut être responsable des contenus des sites
          vers lesquels elle offre des liens qui sont proposés aux utilisateurs
          en tant que service.
        </Typography>
        <Typography variant="body2">
          La création de lien vers le site de l’Association FLUTE est soumise à
          l’autorisation préalable de l’Association FLUTE en écrivant à
          l’adresse mail suivante: laflute.troyes@gmail.com. L’Association FLUTE
          est dégagée de toute responsabilité concernant les liens hypertextes
          vers son site qui ont été établis.
        </Typography>

        <Typography variant="h6">Dispositions générales</Typography>
        <Typography variant="body2">
          L’Association FLUTE peut procéder à la mise à jour de ces conditions
          d’utilisation du site à tout moment. Les conditions générales
          d’utilisation du site sont soumises au droit français et relèvent de
          la compétence des tribunaux français.
        </Typography>
        <Typography variant="body2">
          L’Association FLUTE ne pourra être responsable de tout dommage direct
          ou indirect résultant de votre visite sur son site internet, de
          l’utilisation ou de l’impossibilité d’accéder et/ou d’utiliser le
          contenu de ce site. Cette limitation concerne tout type de dommages
          directs ou indirects y compris la perte de données, de bénéfices et
          l’interruption d’activité.
        </Typography>
      </Box>
    </Box>
  );
};
